import $ from 'jquery';
import moment from 'moment';

export default class Events {
  constructor(element) {
    this.$element = $(element);
    this.process();
    this.ready();
  }

  process() {
    this.$element.find('.node').each((i, element) => {
      const $post = $(element);
      const datetime = $post.find('time.start').attr('datetime');
      const date = moment(datetime);
      const oDates = {
        mon: date.format('MM'),
        day: date.format('DD'),
        yr: date.format('YY'),
      };

      // Dynamically create the date tile for the event display
      const $meta = $post.find('.home-event-meta');
      const markup = data => `<span class="month">${data.mon}</span>/<span class="day">${data.day}</span>/<span class="year">${data.yr}</span>`;
      $meta.find('.event-date').html(markup(oDates));
    });

    this.ready();
  }

  ready() { this.$element.addClass('ready'); }
}
